import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ProfileState = {
  actionLoading: boolean;
  historyListLoading: boolean;
  profileData: any;
  patientList: any[];
  orderList: any[];
  totalOrderList: any[];
  addressList: any[];
  termCondition: any;
  reportList: any[];
  paymentHistory: any[];
  totalpaymentHistory: any[];
  profileMaster: any;
  crmStateList: any[];
  crmCityList: any[];
  cityList: any[];
  pincodeList:any[];
  stateList: any[];
  bookingDetails: any;
  userActivityLog:any[];
  cartList: any[];
  refundDetails: any;
};

let initialState: ProfileState = {
  actionLoading: false,
  historyListLoading:false,
  profileData: {},
  patientList: [],
  orderList: [],
  totalOrderList: [],
  addressList: [],
  termCondition: {} as any,
  reportList: [],
  paymentHistory: [],
  totalpaymentHistory: [],
  profileMaster: {},
  cityList: [],
  pincodeList: [],
  stateList: [],
  crmStateList: [],
  crmCityList: [],
  bookingDetails: {} as any,
  userActivityLog:[],
  cartList:[],
  refundDetails: {} as any
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    actionLoadingResponse(state, action: PayloadAction<any>) {
      state.actionLoading = action.payload;
    },
    historyListLoadingResponse(state, action: PayloadAction<any>) {
      state.historyListLoading = action.payload;
    },
    getProfileResponse(state, action: PayloadAction<any>) {
      state.profileData = action.payload;
    },
    patientListResponse(state, action: PayloadAction<any>) {
      state.patientList = action.payload;
    },
    orderListResponse(state, action: PayloadAction<any>) {
      state.orderList = action.payload;
    },
    totalOrdersResponse(state, action: PayloadAction<any>) {
      state.totalOrderList = action.payload;
    },
    
    addressListResponse(state, action: PayloadAction<any>) {
      state.addressList = action.payload;
    },
    termConditionResponse(state, action: PayloadAction<any>) {
      state.termCondition = action.payload;
    },
    reportListResponse(state, action: PayloadAction<any>) {
      state.reportList = action.payload;
    },
    paymentHistoryResponse(state, action: PayloadAction<any>) {
      state.paymentHistory = action.payload;
    },
    totalPaymentHistoryResponse(state, action: PayloadAction<any>) {
      state.totalpaymentHistory = action.payload;
    },
    userActivityLogResponse(state, action: PayloadAction<any>) {
      state.userActivityLog = action.payload;
    },
    profileMasterResponse(state, action: PayloadAction<any>) {
      state.profileMaster = action.payload;
    },
    cityListResponse(state, action: PayloadAction<any>) {
      state.cityList = action.payload;
    },
    pincodeListResponse(state, action: PayloadAction<any>) {
      state.pincodeList = action.payload;
    },
    stateListResponse(state, action: PayloadAction<any>) {
      state.stateList = action.payload;
    },
    crmCityListResponse(state, action: PayloadAction<any>) {
      state.crmCityList = action.payload;
    },
    crmStateListResponse(state, action: PayloadAction<any>) {
      state.crmStateList = action.payload;
    },
    bookingDetailsResponse(state, action: PayloadAction<any>) {
      state.bookingDetails = action.payload;
    },
    cartListResponse(state, action: PayloadAction<any>) {
      state.cartList = action.payload;
    },
    refundDetailsResponse(state, action: PayloadAction<any>) {
      state.refundDetails = action.payload;
    },
  },
});

export const {
  actionLoadingResponse,
  historyListLoadingResponse,
  crmStateListResponse,
  crmCityListResponse,
  getProfileResponse,
  patientListResponse,
  orderListResponse,
  totalOrdersResponse,
  addressListResponse,
  termConditionResponse,
  reportListResponse,
  paymentHistoryResponse,
  totalPaymentHistoryResponse,
  userActivityLogResponse,
  profileMasterResponse,
  cityListResponse,
  pincodeListResponse,
  stateListResponse,
  bookingDetailsResponse,
  cartListResponse,
  refundDetailsResponse
} = profileSlice.actions;

export default profileSlice.reducer;
